import { defineStore } from 'pinia';
import router from '@/router';
import { useCompaniesStore } from './companyStatic';
import { clearRegisterCache } from './state';

const backendURL = (route: string) => {
  return `${import.meta.env.VITE_API_BASE}/${route}`
}

export enum AccountType {
  ORPHAN='orphan',
  SPRING='spring',
  SUMMER='summer',
}

export interface UserState {
  user_id: number | null
  username: string
  email: string
  profile_image: string
  account_type: AccountType
  seenintro1: boolean
  seenintro2: boolean
  sub_expiry: string
}

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null as UserState | null,
        isLoading: false,
        isSessionValidated: false,
    }),

    getters: {
        isLoggedIn: (state) => !!state.user,
        username: (state) => state.user?.username,
    },

    actions: {
        hydrateState() {
            // this.user = JSON.parse(storedUser)
            const storedUser = localStorage.getItem('user_data');
            if (storedUser) {
                const parsedUser = JSON.parse(storedUser);
            
            // MIGRATION: If they have the old key, map it to the new one
            if (parsedUser.expires_at) {
                parsedUser.sub_expiry = parsedUser.expires_at;
                delete parsedUser.expires_at;
                
                // Resave the corrected object back to local storage
                localStorage.setItem('user_data', JSON.stringify(parsedUser));
            }
            
            this.user = parsedUser;                
            }
        },

        async validateSession(force = false) {
            if (this.isLoggedIn && !force) return;
            this.isLoading = true;
            try {
                const response = await fetch(backendURL('auth/validate-user'), {
                credentials: 'include',
                cache: 'no-store',
                });
                if (response.ok) {
                    const data = await response.json()
                    this.setUser(data);
                    console.log("DATA", data)
                } else {
                    this.user = null;
                }
            } catch(error) {
                await this.logout();
                console.log(error)
            } finally {
                this.isLoading = false;
                this.isSessionValidated = true;
            }
        },

        setUser(userData: UserState | null) {
            this.user = userData;
            if (userData) {
                localStorage.setItem('user_data', JSON.stringify(userData))
            } else {
                localStorage.removeItem('user_data')
            }
        },
        
        async logout() {
            try {
                await fetch(backendURL('auth/logout'), {method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}})
                this.setUser(null);
                useCompaniesStore().clearCache()
                localStorage.removeItem('activeTab');
                clearRegisterCache();
                router.push("/login")
            } catch (err) {
                console.error("Logout failed", err)
            }
        }
    }
})

// ;(globalThis as any).useUserStore = useUserStore;